import { DateTime } from 'luxon';
import { alphanumericRegex, nameSurnameRegex } from 'shell/constants/regex';
import * as yup from 'yup';
import { EventCancellationAire } from './event-cancellation-citizenship';
import { CancellationAireFormVM } from 'cancellations/view-models/cancellation-aire';

export const validationSchema = yup
  .object()
  .shape({
    person: yup.object().shape({
      surname: yup.string().when('withoutSurname', {
        is: false,
        then: yup.string().required('Campo obbligatorio'),
        otherwise: yup.string(),
      }),
      withoutSurname: yup.boolean(),
      name: yup.string().when('withoutName', {
        is: false,
        then: yup.string().required('Campo obbligatorio'),
        otherwise: yup.string(),
      }),
      withoutName: yup.boolean(),
    }),
    generality: yup.object().shape({
      fiscalCode: yup.string().nullable().notRequired(),
      gender: yup.string().required('Campo obbligatorio'),
      aire: yup.string().required('Campo obbligatorio'),
      birthDate: yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .required('Campo obbligatorio')
        .max(DateTime.now(), 'La data deve essere minore della data odierna'),
      // generality italian form
      italian: yup
        .object()
        .nullable()
        .when('isForeign', {
          is: false || undefined,
          then: yup.object().shape({
            municipality: yup
              .object()
              .nullable()
              .shape({
                description: yup.string().required('Campo obbligatorio'),
              }),
          }),
          otherwise: yup.object().shape({
            municipality: yup.object().nullable().shape({
              description: yup.string().notRequired().nullable(),
            }),
            province: yup.string().notRequired().nullable(),
          }),
        }),
      foreign: yup
        .object()
        .nullable()
        .when('isForeign', {
          is: true,
          then: yup.object().shape({
            municipality: yup
              .object()
              .nullable()
              .shape({
                description: yup.string().required('Campo obbligatorio'),
              }),
            state: yup
              .object()
              .nullable()
              .shape({
                value: yup.string().required('Campo obbligatorio'),
              }),
          }),
          otherwise: yup.object().shape({
            municipality: yup.object().nullable().shape({
              description: yup.string().notRequired().nullable(),
            }),
            state: yup.object().nullable().shape({
              value: yup.string().notRequired().nullable(),
            }),
          }),
        }),
      // Other fields generality
      exceptionalBirthPlace: yup.string(),
      municipalityIdentifier: yup.string(),
      istatCode: yup.string().required('Campo obbligatorio'),
      isForeign: yup.boolean(),
    }),
    citizenship: yup.object().shape({
      state: yup.object().shape({}).nullable().required('Campo obbligatorio'),
      note: yup.string(),
      validity: yup.date().nullable().required('Campo obbligatorio').typeError('Data non valida'),
    }),
    fatherhood: yup
      .object()
      .default(null)
      .nullable()
      .shape({
        person: yup.object().shape({
          surname: yup
            .string()
            .when('withoutSurname', {
              is: false || undefined,
              then: yup.string().required('Campo obbligatorio'),
              otherwise: yup.string(),
            })
            .matches(
              nameSurnameRegex,
              'Non sono ammessi caratteri speciali tranne -(trattino) e . (punto)'
            ),
          withoutSurname: yup.boolean(),
          name: yup
            .string()
            .when('withoutName', {
              is: false || undefined,
              then: yup.string().required('Campo obbligatorio'),
              otherwise: yup.string(),
            })
            .matches(
              nameSurnameRegex,
              'Non sono ammessi caratteri speciali tranne -(trattino) e . (punto)'
            ),
          withoutName: yup.boolean(),
        }),
        generality: yup.object().shape({
          gender: yup.string(),
          aire: yup.string(),
          birthDate: yup.date().nullable().typeError('Data non valida'),
          // Other fields generality
          exceptionalBirthPlace: yup
            .string()
            .notRequired()
            .nullable()
            .matches(alphanumericRegex, 'Il campo non è valido'),
          municipalityIdentifier: yup
            .string()
            .notRequired()
            .nullable()
            .matches(alphanumericRegex, 'Il campo non è valido'),
          isForeign: yup.boolean(),
        }),
      }),
    motherhood: yup
      .object()
      .default(null)
      .nullable()
      .shape({
        person: yup.object().shape({
          surname: yup
            .string()
            .when('withoutSurname', {
              is: false || undefined,
              then: yup.string().required('Campo obbligatorio'),
              otherwise: yup.string(),
            })
            .matches(
              nameSurnameRegex,
              'Non sono ammessi caratteri speciali tranne -(trattino) e . (punto)'
            ),
          withoutSurname: yup.boolean(),
          name: yup
            .string()
            .when('withoutName', {
              is: false || undefined,
              then: yup.string().required('Campo obbligatorio'),
              otherwise: yup.string(),
            })
            .matches(
              nameSurnameRegex,
              'Non sono ammessi caratteri speciali tranne -(trattino) e . (punto)'
            ),
          withoutName: yup.boolean(),
        }),
        generality: yup.object().shape({
          gender: yup.string(),
          aire: yup.string(),
          birthDate: yup.date().nullable().typeError('Data non valida'),
          // Other fields generality
          exceptionalBirthPlace: yup.string(),
          municipalityIdentifier: yup.string(),
          isForeign: yup.boolean(),
        }),
      }),
    cancellationAire: yup.object().shape({
      isCitizenshipLoss: yup.boolean().required(),
      cancellationDate: yup
        .date()
        .required('Campo obbligatorio')
        .nullable()
        .typeError('Data non valida')
        .max(
          DateTime.local().plus({ days: 1 }),
          'La data non può essere successiva alla data odierna'
        ),
      typeInitiative: yup.string().required('Campo obbligatorio'),
      subevent: yup.string().when('isCitizenshipLoss', {
        is: true,
        then: yup.string().required('Campo obbligatorio'),
        otherwise: yup.string(),
      }),
      lossCitizenshipDate: yup.date().when('isCitizenshipLoss', {
        is: true,
        then: yup.date().required('Campo obbligatorio').nullable().typeError('Data non valida'),
        otherwise: yup.date().typeError('Data non valida').nullable(),
      }),
      newCitizenship: yup
        .object()
        .shape({
          id: yup.string(),
          value: yup.string(),
        })
        .when('isCitizenshipLoss', {
          is: true,
          then: yup.object().shape({
            id: yup.string().required('Campo obbligatorio'),
            value: yup.string().required('Campo obbligatorio'),
          }),
        }),
      otherwise: yup.object().shape({
        id: yup.string(),
        value: yup.string(),
      }),
      opeLegis: yup
        .object()
        .shape({
          id: yup.string(),
          value: yup.string(),
          subEvent: yup.string(),
        })
        .when(['isCitizenshipLoss', 'subevent'], {
          is: (isCitizenshipLoss: boolean, subevent: string) =>
            isCitizenshipLoss === true &&
            subevent === EventCancellationAire.LossCitizenshipOpeLegis,
          then: yup.object().shape({
            id: yup.string().required('Campo obbligatorio'),
            value: yup.string().required('Campo obbligatorio'),
            subEvent: yup.string().required('Campo obbligatorio'),
          }),
        }),
    }),
  })
  .test('citizenship.validity', 'La data deve essere uguale alla Data di nascita', (values) => {
    const castedValues = values as unknown as CancellationAireFormVM;

    if (
      castedValues.generality?.birthDate &&
      castedValues.citizenship?.validity &&
      (castedValues.generality?.birthDate > castedValues.citizenship?.validity ||
        castedValues.generality?.birthDate < castedValues.citizenship?.validity)
    ) {
      return new yup.ValidationError(
        'La data deve essere uguale alla Data di nascita',
        undefined,
        'citizenship.validity'
      );
    }

    return false;
  });
